<template>
  <div class="wrapper-preview-about">
    <div>
      <div class="pb-2 pt-4 px-3">
        <div
          class="d-flex align-items-center"
          :class="{ 'justify-content-between': showKnowMore }"
        >
          <button
            v-if="lessonId && !isLocked"
            class="btn btn-play text-white me-3"
            @click.stop="
              $router.push({
                name: playerRoute,
                params: { id: courseId, lesson_id: lessonId },
              })
            "
          >
            <i class="icon-play btn-circle"></i>
          </button>
          <button
            v-if="showKnowMore && !isLocked"
            @click.stop="
              $router.push({
                name: aboutRoute,
                params: { id: item.id },
              })
            "
            class="btn about-route btn-secondary btn-radius me-3"
          >
            <i class="icon-outline-warn-1 me-2"></i>
            Saiba mais
          </button>
          <add-to-list
            v-if="!isLocked"
            :item="item"
            :is-conference="isConference"
            :isShort="lessonId"
            class="d-none d-lg-block p-0"
          />
        </div>

        <div class="d-lg-none mb-3 mt-2">
          <add-to-list
            v-if="!isLocked"
            :is-conference="isConference"
            :item="item"
            :isShort="lessonId"
          />
        </div>
      </div>

      <div class="px-3 pb-3 px-lg-4 pb-lg-4">
        <div class="mb-2">
          <span>Curso: </span>
          <span class="fw-bold">
            {{ item.name }}
          </span>
        </div>

        <div class="mb-2">
          <span>{{ teacherLabel }}: </span>
          <span class="fw-bold">
            {{ teacherNames }}
          </span>
        </div>

        <div v-if="item.partner" class="mb-2">
          <span>Curso em parceria com</span>
          <span class="fw-bold">
            {{ item.partner }}
          </span>
        </div>

        <div>
          <span class="me-4">
            <i class="icon-monitor me-2" />
            <span>
              <span class="fw-bold">
                {{ item.total_lessons }}
              </span>
              {{ isConference ? "Vídeos" : "Videoaulas" }}
            </span>
          </span>

          <span>
            <i class="icon-clock me-2" />
            <span>
              <span class="fw-bold"> {{ item.total_hours }}h </span>
              <span>Carga Horária</span>
            </span>
          </span>
        </div>
        <div v-if="isLocked" class="px-4 pt-3">
          <router-link
            :to="{
              name: 'plans',
            }"
            class="btn btn-outline-primary text-primary"
          >
            <i class="icon-lock"></i> <span>Faça upgrade do seu plano</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import isConference from "@/functions/mixins/isConference.js";
import AddToList from "../buttons/AddToList.vue";
import { mapState } from "vuex";
import get from "lodash/get";

export default {
  mixins: [isConference],
  components: { AddToList },
  props: {
    item: {
      required: true,
      type: Object,
    },
    showKnowMore: {
      type: Boolean,
      default: true,
    },
    isLocked: {
      type: Boolean,
      default: false,
    },
    isVertical: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState("courses", ["started_courses", "completed_courses"]),
    teacherLabel() {
      return this.item?.teachers.length > 1 ? "Professores" : "Professor";
    },
    teacherNames() {
      const limit = 70;
      if (this.item.teachers && this.item.teachers?.length) {
        const names = this.item.teachers.map(({ name }) => name).join(", ");
        const ellipses = names.length > limit ? "..." : "";
        return `${names.slice(0, limit)}${ellipses}`;
      }

      return "";
    },
    backgroundUrl() {
      if (this.item?.cover) return this.item.cover;

      if (this.item.course && this.item.course.cover)
        return this.item.course.cover;

      return "";
    },
    isStarted() {
      const id_to_check = get(this.item, "course.id", this.item.id);

      const progress_record = this.started_courses.find(
        (c) => c.course.id == id_to_check
      );

      return progress_record && progress_record?.progress < 100;
    },
    bgStyle() {
      return `background: url(${this.backgroundUrl}), #333; background-size: cover; background-repeat: no-repeat; background-position: center;`;
    },
    courseId() {
      return this.item.id;
    },
    lessonId() {
      return get(this.item, "last_lesson.id", undefined);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper-preview-about {
  background: black;

  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;

  span {
    font-size: 12px;
  }

  .bg-item {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    aspect-ratio: 392/217;
  }
}
</style>
